"use client"

import { useEffect, useState } from "react"
import { useRouter, useT } from "@/lib/router"
import { Icon } from "./ui"

export function BackToTop() {
  const t = useT()
  const { route } = useRouter()
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    const update = () => setVisible(window.scrollY > 400)
    update()
    window.addEventListener("scroll", update, { passive: true })
    return () => window.removeEventListener("scroll", update)
  }, [route.path, route.locale])

  // The floating shortcut is part of the home-page experience only.
  if (!visible || route.path !== "/") return null

  const label = t({ en: "Back to top", ar: "العودة إلى أعلى الصفحة" })

  return (
    <button
      type="button"
      aria-label={label}
      title={label}
      onClick={() => {
        document.getElementById("page-top")?.focus({ preventScroll: true })
        window.scrollTo({
          top: 0,
          behavior: window.matchMedia("(prefers-reduced-motion: reduce)").matches
            ? "instant"
            : "smooth",
        })
      }}
      className="group fixed end-6 bottom-[calc(1.5rem+env(safe-area-inset-bottom))] z-40 flex h-12 w-[51px] items-center justify-center text-white"
    >
      <span
        aria-hidden="true"
        className="absolute inset-0 bg-blue transition-colors group-hover:bg-ink"
        style={{
          maskImage: "url(/brand/back-to-top-shape.svg)",
          maskSize: "contain",
          maskPosition: "center",
          maskRepeat: "no-repeat",
        }}
      />
      <Icon name="arrow-up" className="relative size-5" />
    </button>
  )
}
